const translations = {
    aircraft: 'Aircraft',
    aircraftCount: '— {count} selected',
    aircraftCountOf: '— {count} of {total} selected',
    aircraftUnit: 'aircraft',
    apply: 'Apply',
    assignPilot: 'Assign pilot',
    autoPopulated: 'Auto-populated',
    backLink: 'FAA Reports',
    bulkAssignPilot: 'Assign pilot:',
    clearSelection: 'Clear selection',
    columnDate: 'Date',
    columnDuration: 'Duration',
    columnFlightTime: 'Flight Time',
    columnFlights: 'Flights',
    columnLocation: 'Location',
    columnPilot: 'Pilot',
    columnSource: 'Source',
    columnType: 'Type',
    companyDetails: 'Company Details',
    editOrgSettings: 'Edit in Organization Settings',
    faaRegistration: 'FAA Reg: ',
    fieldAddress: 'Address',
    fieldCity: 'City',
    fieldCoaNumber: 'COA Number',
    fieldCompanyName: 'Company Name',
    fieldExemptionDocket: 'Exemption Docket',
    fieldExemptionNumber: 'Exemption No.',
    fieldPhone: 'Phone',
    fieldState: 'State',
    fieldZip: 'Zip',
    flightFetchFailed:
        'Could not load flights for this aircraft. Toggle it off and back on to retry.',
    flightLogs: 'Flight Logs',
    flightsUnit: 'flights',
    generateReport: 'Generate Report',
    infoBar:
        'Showing all flights for {month}. Click rows to select, then bulk-assign a pilot — or update each row individually.',
    loadingCompanyDetails: 'Loading company details…',
    loadingFlightLogs: 'Loading flight logs...',
    missingFields: '{count} fields missing',
    missingFieldsWarning: 'Missing fields will appear blank in the exported report.',
    noFlights: 'No flights loaded yet',
    noFlightsHint: 'Choose a reporting month and aircraft in the panel on the left.',
    notProvided: 'Not provided',
    readOnly: 'Read-only',
    reportSetup: 'Report Setup',
    reportingMonth: 'Reporting Month',
    selectMonth: 'Select month…',
    selectPilot: 'Select pilot…',
    selected: 'selected',
    setupPrompt: 'Select a month and at least one aircraft to load flight logs.',
    statsSeparator: ' · ',
    subtitle: 'Select a month and aircraft, then review and assign pilots to the flight logs.',
    title: 'Create FAA Report',
    totalLabel: 'total',
    viewInFlights: 'View in Flights & Maps'
};

export default translations;
